import { Component } from 'react';
import type { ReactChild } from 'react';

import { GenericAppError } from './components/generic/AppError';

type ErrorBoundaryProps = {
  children: ReactChild;
};

type ErrorBoundaryState = {
  hasError: boolean;
};

/**
 * Catches Errors which originate in the component tree below it.
 * Displays GenericAppError if there is an error, otherwise renders the children.
 *
 * Note: Must be a class Component in order to use getDerivedStateFromError.
 */
export default class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state = {
    hasError: false,
  }

  static getDerivedStateFromError() {
    return {
      hasError: true,
    };
  }

  render() {
    const { children } = this.props;
    const { hasError } = this.state;
    return hasError
      ? <GenericAppError />
      : children;
  }
}
